import { GradeBandName } from "@/constants/GradeAndLexileLevels";
import { LANG } from "@/constants/Language/Language";
import {
  type IContentProvider,
  IContentImage,
} from "@/home/TeacherHomepage/types/IContent";
import { ContentType } from "@/view/constants/contentTypes";
import { Article } from "./Article.interface";
import { GenerationGeniusAPIResponse } from "./GenerationGenius.interface";
import { InteractiveVideo } from "./InteractiveVideo.interface";
import { PageViewModel } from "./ContentPageViewModel.interface";
import { Bundle } from "./Bundle.interface";

// A base class to represent all the content. It's useful when we want to work
// with duck-typed objects that have similar interface but defined as different types.
export interface Content {
  id: string;
}
export interface ContentLevel extends Content {
  grade_band: GradeBandName;
  language: LANG;
}

export enum CONTENT_PUBLISH_STATUS {
  PUBLISHED = "PUBLISHED",
  DRAFT = "DRAFT",
  CHANGED = "CHANGED",
  ARCHIVED = "ARCHIVED",
}

export type LangstonContent =
  | Article
  | InteractiveVideo
  | GenerationGeniusAPIResponse
  | Bundle;

export interface RawLangstonContentResponse extends Content {
  data: LangstonContent;
  content_type: ContentType;
  is_visible: boolean;
  modified_date: string;
  checksum: string;
  created_date: string;
  visibility_markers?: Array<any>;
  // Content types with no support for the page view model return an
  // empty document "{}".
  page_viewmodel: PageViewModel | Record<string, never>;
}

export interface LangstonContentResponse
  extends Omit<RawLangstonContentResponse, "page_viewmodel"> {
  page_viewmodel: PageViewModel | undefined;
}

export interface ContentResponse {
  category: string;
  content_id: string;
  content_provider?: IContentProvider;
  content_type: string;
  date_created: string;
  date_lite_product_grant_expires?: string | null;
  date_modified: string;
  date_published: string;
  features?: {
    available_in_spanish: boolean | undefined;
    has_power_words: boolean | undefined;
  };
  grade_level: string[] | null;
  header_id?: number;
  image: IContentImage;
  is_lite: boolean;
  is_premium: boolean;
  language?: string;
  member_count: number;
  members: [];
  reading_skills: string[] | null;
  selector: null;
  short_title: string;
  slug?: string;
  story_content_id: string;
  story_type?: string;
  title: string;
}
